/** Unified filter-pill react-select (borderless inside pill container). */
export const getModernGridFilterPillSelectStyles = (baseStyles, isDarkMode) => {
  const text = isDarkMode ? "#e9ecef" : "#1e293b";

  return {
    ...baseStyles,
    control: (provided, state) => ({
      ...provided,
      minHeight: "30px",
      height: "30px",
      backgroundColor: "transparent",
      border: "none",
      borderRadius: 0,
      boxShadow: "none",
      cursor: "pointer",
      minWidth: 0,
      "&:hover": {
        backgroundColor: "transparent",
      },
      ...(state.isFocused && {
        backgroundColor: "transparent",
        boxShadow: "none",
      }),
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 2px 0 0",
      height: "30px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: text,
      fontSize: "13px",
      fontWeight: 500,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: isDarkMode ? "#adb5bd" : "#64748b",
      fontSize: "13px",
      fontWeight: 500,
    }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "0 0 0 4px",
      color: isDarkMode ? "#94a3b8" : "#64748b",
    }),
    menu: (provided) => ({
      ...(baseStyles.menu ? baseStyles.menu(provided) : provided),
      zIndex: 9999,
      borderRadius: "10px",
      overflow: "hidden",
      marginTop: 4,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };
};

/** Compact pill-style react-select for header controls row. */
export const getModernGridToolbarSelectStyles = (baseStyles, isDarkMode) => {
  const borderColor = isDarkMode ? "#404040" : "#e5e7eb";
  const bg = isDarkMode ? "#2d3436" : "#ffffff";
  const text = isDarkMode ? "#f1f3f5" : "#1f2937";

  return {
    ...baseStyles,
    control: (provided, state) => ({
      ...provided,
      minHeight: "34px",
      height: "34px",
      backgroundColor: bg,
      border: `1px solid ${borderColor}`,
      borderRadius: "999px",
      boxShadow: "none",
      cursor: "pointer",
      paddingLeft: "2px",
      paddingRight: "2px",
      "&:hover": {
        borderColor: isDarkMode ? "#6c757d" : "#d1d5db",
      },
      ...(state.isFocused && {
        borderColor: isDarkMode ? "#868e96" : "#9ca3af",
        boxShadow: "none",
      }),
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 6px",
      height: "32px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: text,
      fontSize: "13px",
      fontWeight: 500,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: isDarkMode ? "#adb5bd" : "#6b7280",
      fontSize: "13px",
      fontWeight: 500,
    }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "0 6px",
      color: isDarkMode ? "#adb5bd" : "#6b7280",
    }),
    menu: (provided) => ({
      ...(baseStyles.menu ? baseStyles.menu(provided) : provided),
      zIndex: 9999,
      borderRadius: "10px",
      overflow: "hidden",
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };
};
